/**
 * Phase 3 - French translations module
 */
import enBase from './en.js';
import { translationsFr } from '../../utils/translations/translations.fr.js';
import { plansTranslationsFr } from '../../utils/translations/plans/plansTranslations.fr.js';

const merged = { ...enBase, ...translationsFr, ...plansTranslationsFr };
export default merged;
